import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import BrandLogosStrip from './components/BrandLogosStrip';
import TrustBar from './components/TrustBar';
import ProblemSection from './components/ProblemSection';
import ServicesSection from './components/ServicesSection';
import WhySection from './components/WhySection';
import StatsSection from './components/StatsSection';
import HowItWorksSection from './components/HowItWorksSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <BrandLogosStrip />
      <TrustBar />
      <ProblemSection />
      <ServicesSection />
      <WhySection />
      <StatsSection />
      <HowItWorksSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
